<script lang="ts">
  import classnames from "classnames"
  import { omit } from "$lib/utils/object";

  const attributes = omit($$restProps, "class")
</script>

<section class="{classnames('section-faq', $$props.class)}" {...attributes}>
  <div class="accordion-container">
    <slot />
  </div>
</section>

<style type="text/scss" lang="scss" scoped>
  :global(.accordion-container > * + *) {
    @apply border-t border-gray-900 border-opacity-30;
  }
</style>
